import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    linkCell: {
        textDecoration: "none",
        color: "inherit",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        height: "100%",
        justifyContent: "inherit",
        cursor: "pointer"
    },
    toolBarContainer:{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "22px",
      flexWrap: "nowrap"
    },
    filterContainer: {
        display: "flex",
        justifyContent: "center",
    },
    toolBarFilterButton : {
      fontFamily: "Inter",
      fontSize: "10px",
      fontWeight: 600,
      backgroundColor: theme.palette.primary.primary50,
      color: theme.palette.primary.primary800,
      border: "0.5px solid " + theme.palette.primary.primary800,
      borderRadius: "12px",
      padding: "0.2rem 0.5rem",
      marginRight: "1rem",
      textTransform: "none",

        "&:hover": {
            backgroundColor: theme.palette.primary.primary200,
        },
    },
    countBadge: {
        marginLeft: "-19px",
        marginRight: "15px",
        height: "85%",
        "& .MuiBadge-badge": {
            backgroundColor: theme.palette.warning.warning600 + " !important",
            color: "white",
            fontWeight: 600
        },
    },
    toolBarFilterAnswerButton : {
        boxShadow: "none !important",
        marginLeft: "-9px",
        border: "0.5px solid " + theme.palette.primary.primary800 + " !important",
        transition: "0.2s ease-in-out",
    },
    toolBarFilterAnswerButtonActive : {
        backgroundColor: theme.palette.primary.primary800 + " !important",
        color: "white !important",
            transition: "0.2s ease-in-out",
        "&:hover": {
            transition: "0.2s ease-in-out",
            backgroundColor: theme.palette.primary.primary800 + " !important",
            borderColor: theme.palette.primary.primary800 + " !important",
        },

    },
    toolBarFilterAnswerButtonInactive : {
        backgroundColor: theme.palette.primary.primary50+ " !important",
        color: theme.palette.primary.primary800 + " !important",
        "&:hover": {
            backgroundColor: theme.palette.primary.primary200 + " !important",
        },
    },
    toolBarColumnsButton: {
        backgroundColor: theme.palette.grey.grey300,
        color: "white",
        borderRadius: "12px",
        padding: "0.3rem 0.5rem",
        marginRight: "1rem",
        minWidth: "40px",

        "&:hover": {
            backgroundColor: theme.palette.grey.grey400,
        },

        "& .MuiButton-startIcon": {
            margin: "0 !important",
        }
    },
    toolBarFilterAnswerButtonContent: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
    },
    toolBarDensitySelector: {
        backgroundColor: theme.palette.grey.grey300,
        color: "white",
        borderRadius: "12px",
        padding: "0.3rem 0",
        marginRight: "1rem",
        minWidth: "40px",

        "&:hover": {
            backgroundColor: theme.palette.grey.grey400,
        },

        "& .MuiButton-startIcon": {
            margin: "0 !important",
        }
    },
    toolBarExport: {
        fontFamily: "Inter",
        fontSize: "10px",
        color: theme.palette.grey.grey400 + " !important",
        textTransform: "none",
        fontWeight: 600,
    },
    additionalLeft: {
        position: "relative",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
    },
}));

export default useStyles;
